import { render, staticRenderFns } from "./ProductListSelector.vue?vue&type=template&id=970a573e&scoped=true"
import script from "./ProductListSelector.vue?vue&type=script&lang=ts"
export * from "./ProductListSelector.vue?vue&type=script&lang=ts"
import style0 from "./ProductListSelector.vue?vue&type=style&index=0&id=970a573e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970a573e",
  null
  
)

export default component.exports